export default function SafetyHarborHowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            How Fast Passport Center Works for Safety Harbor Travelers
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Our courier-based expedited process means you never have to visit a passport agency in Tampa or Orlando. Start online, ship overnight, and receive your passport in as little as 24 hours.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {[
            {
              icon: "ri-computer-line",
              step: "Step 1",
              title: "Choose Your Speed",
              desc: "Select your timeline — emergency 24-hour, expedited 2–9 day, or standard 3–5 week service — and complete your order online in minutes.",
            },
            {
              icon: "ri-file-list-3-line",
              step: "Step 2",
              title: "Receive Instructions",
              desc: "We send you a detailed checklist with all required forms, documents, and photos. Every application is reviewed by our document specialists.",
            },
            {
              icon: "ri-truck-line",
              step: "Step 3",
              title: "Ship or Courier Pickup",
              desc: "Send your documents via overnight shipping from any UPS or FedEx location in Safety Harbor, Dunedin, Palm Harbor, or Clearwater. Courier pickup available throughout Pinellas County.",
            },
            {
              icon: "ri-passport-line",
              step: "Step 4",
              title: "Get Your Passport Fast",
              desc: "We hand-carry your application to a regional passport agency using our reserved courier slots. Your passport ships back to you via secure delivery.",
            },
          ].map((item, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 p-6 text-center hover:border-[#F6C344] transition-all duration-200">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1A365D] mx-auto mb-5">
                <i className={`${item.icon} text-[#F6C344] text-xl`}></i>
              </div>
              <p className="text-[#F6C344] text-xs font-bold uppercase tracking-wider mb-2">{item.step}</p>
              <h3 className="font-bold text-[#1A365D] text-base mb-3">{item.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Step connectors (desktop only) */}
        <div className="hidden md:flex items-center justify-center gap-2 mt-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center gap-2">
              <div className="w-16 h-px bg-[#F6C344]"></div>
              <i className="ri-arrow-right-line text-[#F6C344] text-xs"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}